import { IAllProps } from '@tinymce/tinymce-react';

declare const __TINYMCE_VERSION__: string;
export const tinymceScriptSrc = `https://cdn.jsdelivr.net/npm/tinymce@${__TINYMCE_VERSION__}/tinymce.min.js`;

export const tinymceInitConfig: IAllProps['init'] = {
  plugins: ['advlist', 'autolink', 'lists', 'link', 'image', 'table', 'emoticons', 'quickbars'],
  toolbar: `
    blocks |
    bold italic strikethrough |
    forecolor backcolor |
    alignleft aligncenter alignright |
    bullist numlist |
    emoticons image link table |
    removeformat
  `,
  branding: false,
  promotion: false,
  resize: true,
  menubar: false,
  contextmenu: false,
  quickbars_insert_toolbar: false,
  quickbars_selection_toolbar: 'bold italic strikethrough | forecolor backcolor | link',
  min_height: 150,
  height: 150,
  auto_focus: true
};
